import {create, State, StateCreator, StoreMutatorIdentifier} from 'zustand'
import {UserDTO} from "../api/model/user/UserDTO";
import {CompanyDTO} from '@energy-advice/easas-api';

type Logger = <
    T extends State,
    Mps extends [StoreMutatorIdentifier, unknown][] = [],
    Mcs extends [StoreMutatorIdentifier, unknown][] = []
>(
    f: StateCreator<T, Mps, Mcs>,
    name?: string
) => StateCreator<T, Mps, Mcs>

type LoggerImpl = <T extends State>(
    f: StateCreator<T, [], []>,
    name?: string
) => StateCreator<T, [], []>

const loggerImpl: LoggerImpl = (f, name) => (set, get, store) => {
    type T = ReturnType<typeof f>
    const loggedSet: typeof set = (...a) => {
        set(...a)
        console.log(...(name ? [`${name}:`] : []), get())
    }
    store.setState = loggedSet

    return f(loggedSet, get, store)
}

export const logger = loggerImpl as unknown as Logger


interface UserState {
    companyContext?: CompanyDTO ;
    currentUser?: UserDTO;
    isCurrentUserLoaded: boolean;
    setCompanyContext: (company?: CompanyDTO) => void;
    setCurrentUser: (user?: UserDTO) => void;
}

export const useUserState = create<UserState>()(
    set => ({
        companyContext: undefined,
        currentUser: undefined,
        isCurrentUserLoaded: false,
        setCompanyContext: (company?: CompanyDTO) => set(() => ({ companyContext: company })),
        setCurrentUser: (user?: UserDTO) => set(() => ({
            currentUser: user,
            isCurrentUserLoaded: true,
            companyContext: user?.accessibleCompanies?.[0]
        }))
    }),
)